import PropTypes from "prop-types";
import * as React from "react";
import { BookingSubmitButton } from "./BookingSubmitButton";
import { TosCheckbox } from "./TosCheckbox";

export const RequestToBookSection = ({
  urlPrefix,
  handleRequestSuccess,
  checkTransactability,
  bookingId,
  SSOid,
}) => {
  const [tosAccepted, setTosAccepted] = React.useState(true);

  return (
    <>
      <TosCheckbox
        urlPrefix={urlPrefix}
        isChecked={tosAccepted}
        setIsChecked={(isChecked) => {
          setTosAccepted(isChecked);
          analytics.track("tc_checkbox_toggled", {
            is_accepted: isChecked,
            booking_id: bookingId,
            sso_id: SSOid,
          });
        }}
      />

      <div style={{ marginTop: "32px" }}>
        <BookingSubmitButton
          handleRequestSuccess={handleRequestSuccess}
          checkTransactability={checkTransactability}
          disabled={!tosAccepted}
        />
      </div>
    </>
  );
};

RequestToBookSection.propTypes = {
  urlPrefix: PropTypes.string.isRequired,
  handleRequestSuccess: PropTypes.func.isRequired,
  checkTransactability: PropTypes.func.isRequired,
  bookingId: PropTypes.string,
  SSOid: PropTypes.string,
};
